const DEFAULT_API_BASE_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://carnitrack.com'
    : 'http://localhost:8000';

/** Public API host only (tenant discovery). Defaults match API_BASE_URL when unset. */
const DEFAULT_PUBLIC_API_URL = DEFAULT_API_BASE_URL;

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL;

/**
 * Public API base for discover + tenant registration CSRF.
 * Set to empty string or `same-origin` in dev with package.json `proxy` so requests hit the
 * CRA dev server origin — Django can set `csrftoken` for that origin (cross-origin fetches
 * often never store the cookie → "CSRF cookie not set" even when GET /auth/csrf/ returns 200).
 */
const rawPublicApi = process.env.REACT_APP_PUBLIC_API_URL;
export const PUBLIC_API_URL =
  rawPublicApi === '' || String(rawPublicApi).trim() === 'same-origin'
    ? ''
    : rawPublicApi || DEFAULT_PUBLIC_API_URL;

/**
 * Fallback origin for GET /auth/me/ and POST /auth/logout/ when no tenant URL is stored yet
 * (e.g. single-tenant dev where you set this to the tenant API). After email-first login,
 * the client uses localStorage `carnitrack.tenantApiBaseUrl` (see authClient.js).
 */
export const SESSION_API_BASE_URL =
  process.env.REACT_APP_SESSION_API_BASE_URL || API_BASE_URL;

/**
 * Documented SPA origin for local dev (same hostname as tenant API, port 3000).
 * Align with `web_app_base_url` from discover-tenants. Used for hints only.
 */
export const DEV_SPA_ORIGIN = process.env.REACT_APP_DEV_SPA_ORIGIN || '';


/**
 * Where authenticated users should land after the tenant login handshake.
 * `django` = server-rendered tenant app on the API host, `spa` = React app.
 */
export const POST_LOGIN_TARGET =
  String(process.env.REACT_APP_POST_LOGIN_TARGET || 'django').toLowerCase() === 'spa'
    ? 'spa'
    : 'django';
